/* global locale */

import Country from './country.js'
import Api from '../local_fetch_call'

export default {
  blockedCountries() {
    return  Country.blockedCountries()
  },

  rwcCountryNamesAndCodes() {
    return Country.rwcCountryNamesAndCodes()
  },

  countryNamesAndCodes() {
    return Country.countryNamesAndCodes()
  },

  countryStates(country_code, localeOverride = locale) {
    return Api.fetchWithoutLocale(`/api/countries/${country_code}.json?locale=${localeOverride}`, 'GET', null).
      then(response => { return response.states })
  }
}
